import React from 'react'
import { Zoom } from 'react-awesome-reveal'
import { Container, Icon } from 'semantic-ui-react'
import bannerPic1 from '../Pictures/banner1.jpg'
import communityPic from '../Pictures/Gallery/GetTogether 2023/GetTogether2023(1).jpg'
import { Executives as executives } from '../Data/Executives'

export default function About() {
  const bannerStyle = {
    backgroundImage: `url(${bannerPic1})`,
  }

  const aims = [
    {
      icon: 'users',
      title: 'Unite the Community',
      desc: 'Bring together Ghanaians and Czechs of Ghanaian heritage living across the Czech Republic.',
    },
    {
      icon: 'heart',
      title: 'Mutual Care & Welfare',
      desc: 'Foster proactive welfare support and care for members during key life milestones and times of need.',
    },
    {
      icon: 'trophy',
      title: 'Celebrate Achievements',
      desc: 'Recognize and honor the academic, cultural, and professional accomplishments of community members.',
    },
    {
      icon: 'globe',
      title: 'Bilateral Relations',
      desc: 'Nurture and strengthen cultural bridges and cordial relationships between Ghana and the Czech Republic.',
    },
    {
      icon: 'handshake',
      title: 'Socio-Economic Support',
      desc: 'Support meaningful development initiatives both within our local diaspora community and in Ghana.',
    },
  ]

  const activities = [
    {
      title: 'Periodic General Meetings',
      desc: 'Democratic forums for updates, deliberations, communal discussions, and decision-making.',
    },
    {
      title: 'Educational & Integration Seminars',
      desc: 'Workshops addressing Czech residency, employment, healthcare, legal guidelines, and student life.',
    },
    {
      title: 'Community Welfare & Voluntary Action',
      desc: 'Direct compassionate assistance for hospitalizations, bereavement, births, and civic volunteer drives.',
    },
    {
      title: 'National Celebrations & Holidays',
      desc: 'Commemorating Ghana Independence Day and Czech public celebrations in joyful solidarity.',
    },
    {
      title: 'Get-Togethers, Sports & Tourism',
      desc: 'Annual summer grill gatherings, friendly football/badminton tournaments, and excursions across regions.',
    },
    {
      title: 'Diplomatic Liaison with the Embassy',
      desc: 'Close partnership with the Ghana Embassy for official endorsements, consular guidance, and outreach.',
    },
  ]

  return (
    <div id='aboutPage'>
      {/* Hero Banner */}
      <section className='aboutHero' style={bannerStyle}>
        <div className='aboutHeroOverlay'></div>
        <div className='aboutHeroContent'>
          <Zoom triggerOnce>
            <span className='aboutHeroBadge'>Community & Heritage</span>
            <h1 className='aboutHeroHeading'>About Us</h1>
            <div className='goldAccentLine' style={{ margin: '14px auto 20px auto' }}></div>
            <p className='aboutHeroSubheading'>
              Fostering unity, welfare, and integration for the Ghanaian diaspora in the Czech Republic since 2009.
            </p>
            <a href='#executives' className='aboutScrollLink'>
              Executives <Icon name='arrow down' />
            </a>
          </Zoom>
        </div>
      </section>

      {/* Story & History Section */}
      <section className='homeSection aboutStorySection'>
        <Container>
          <div className='aboutStoryGrid'>
            <div className='aboutStoryText'>
              <span className='sectionBadge'>Our Story</span>
              <h2 className='homeSectionTitle'>History & Purpose</h2>
              <div className='goldAccentLine'></div>
              <p className='homeIntroText'>
                The history of Ghana Union Czech Republic dates back to 2009, with official registration established in October 2013 with the Czech authorities. Before this milestone, several grassroots initiatives laid the groundwork for unifying Ghanaians throughout the Czech Republic.
              </p>
              <p className='homeIntroText'>
                Today, Ghana Union serves as the official, recognized voice representing the Ghanaian community. As a registered welfare, non-profit, and non-governmental association, our governance is rooted in our constitution and by-laws administered by our democratically elected Executive Committee.
              </p>
              <p className='homeIntroText'>
                Beyond Prague, our vibrant Brno Chapter in the South Moravian Region ensures regional connectivity with dedicated coordinators. Our activities are sustained through membership subscriptions, benevolent contributions, and communal fundraising initiatives.
              </p>
            </div>

            <div className='aboutStoryImageWrapper'>
              <img
                src={communityPic}
                alt='Ghana Union Community Event'
                className='aboutStoryImage'
              />
            </div>
          </div>
        </Container>
      </section>

      {/* Aims Section (Non-Card Editorial) */}
      <section className='homeSection aboutAimsSection'>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Core Pillars</span>
            <h2 className='homeSectionTitle'>Aims of the Union</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              Our founding objectives guide every initiative, event, and partnership we organize.
            </p>
          </div>

          <div className='aboutAimsGrid'>
            {aims.map((aim, idx) => (
              <article className='aboutAimItem' key={idx}>
                <div className='aboutAimIconBox'>
                  <Icon name={aim.icon} />
                </div>
                <h3 className='aboutAimTitle'>{aim.title}</h3>
                <p className='aboutAimDesc'>{aim.desc}</p>
              </article>
            ))}
          </div>
        </Container>
      </section>

      {/* Activities Section (Non-Card Editorial) */}
      <section className='homeSection aboutActivitiesSection'>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Community Life</span>
            <h2 className='homeSectionTitle'>What We Do Together</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              We create opportunities for fellowship, mutual support, cultural preservation, and smooth integration.
            </p>
          </div>

          <div className='aboutActivitiesGrid'>
            {activities.map((act, idx) => (
              <article className='aboutActivityItem' key={idx}>
                <div className='aboutActivityIconBox'>
                  <Icon name='check circle' />
                </div>
                <div className='aboutActivityBody'>
                  <h4 className='aboutActivityTitle'>{act.title}</h4>
                  <p className='aboutActivityDesc'>{act.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>

      {/* Executives / Leadership Section */}
      <section id='executives' className='homeSection aboutExecutivesSection'>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Leadership</span>
            <h2 className='homeSectionTitle'>Executive Committee</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              Dedicated leaders committed to serving the Ghanaian community in the Czech Republic.
            </p>
          </div>

          <div className='aboutExecsGrid'>
            {executives.map(exec => (
              <article className='aboutExecItem' key={exec.id}>
                <div className='aboutExecPhotoWrapper'>
                  <img
                    src={exec.portrait}
                    alt={exec.name}
                    className='aboutExecPhoto'
                    loading='lazy'
                  />
                </div>
                <div className='aboutExecDetails'>
                  <span className='aboutExecPositionBadge'>{exec.position}</span>
                  <h3 className='aboutExecName'>{exec.name}</h3>
                  {exec.number && (
                    <a href={`tel:${exec.number}`} className='aboutExecPhoneLink'>
                      <Icon name='phone' /> {exec.number}
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>
    </div>
  )
}
